export const useModalNotAuthorized = (title: string) => {
	const handleLinkToWhatsapp = () => {
		const message = `¡Hola! Me interesa saber más sobre lo beneficio ${title}`;

		window.open(`https://wa.me/+525633064096?text=${message}`, '_blank');
	};

	return {
		handleLinkToWhatsapp,
	};
};
